/* eslint-disable */
import React, { useState, useMemo } from 'react';
import './RangePicker.css';

const MONTH_NAMES = [
    'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
];

const DAY_NAMES_MINI = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

export default function RangePicker({ initialStart, initialEnd, onSelect, onClose }) {
    const [viewDate, setViewDate] = useState(new Date(initialStart || new Date()));
    const [selectionStart, setSelectionStart] = useState(initialStart);
    const [selectionEnd, setSelectionEnd] = useState(initialEnd);
    const [hoverDate, setHoverDate] = useState(null);

    const firstMonth = useMemo(() => {
        const d = new Date(viewDate.getFullYear(), viewDate.getMonth(), 1);
        return d;
    }, [viewDate]);

    const secondMonth = useMemo(() => {
        const d = new Date(viewDate.getFullYear(), viewDate.getMonth() + 1, 1);
        return d;
    }, [viewDate]);

    const navigate = (dir) => {
        const next = new Date(viewDate);
        next.setMonth(next.getMonth() + dir);
        setViewDate(next);
    };

    const isSameDay = (d1, d2) => {
        if (!d1 || !d2) return false;
        return d1.getFullYear() === d2.getFullYear() &&
               d1.getMonth() === d2.getMonth() &&
               d1.getDate() === d2.getDate();
    };

    const isInRange = (date) => {
        if (!selectionStart) return false;
        const start = selectionStart;
        const end = selectionEnd || hoverDate;
        if (!end) return isSameDay(date, start);
        
        const d = new Date(date);
        d.setHours(0,0,0,0);
        const s = new Date(start);
        s.setHours(0,0,0,0);
        const e = new Date(end);
        e.setHours(0,0,0,0);

        const [min, max] = s < e ? [s, e] : [e, s];
        return d >= min && d <= max;
    };

    const handleDateClick = (date) => {
        const d = new Date(date);
        d.setHours(0,0,0,0);

        if (!selectionStart || (selectionStart && selectionEnd)) {
            setSelectionStart(d);
            setSelectionEnd(null);
        } else {
            const start = new Date(selectionStart);
            start.setHours(0,0,0,0);

            if (d < start) {
                // Reverse selection: current date becomes new start, old start becomes end
                setSelectionStart(d);
                setSelectionEnd(start);
                onSelect(d, start);
            } else if (isSameDay(d, start)) {
                // Clicking same day twice resets or selects single day? 
                // User said "klick auf nen anderes Datum ist das enddatum".
                // Let's treat it as a single day range for now if they click the same.
                setSelectionEnd(d);
                onSelect(start, d);
            } else {
                setSelectionEnd(d);
                onSelect(start, d);
            }
        }
    };

    const renderMonth = (monthDate) => {
        const year = monthDate.getFullYear();
        const month = monthDate.getMonth();
        const firstDay = (new Date(year, month, 1).getDay() + 6) % 7; // Mo=0
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        
        const days = [];
        for (let i = 0; i < firstDay; i++) days.push(null);
        for (let i = 1; i <= daysInMonth; i++) days.push(new Date(year, month, i));

        return (
            <div className="rp-month">
                <div className="rp-month-header">
                    {MONTH_NAMES[month]} {year}
                </div>
                <div className="rp-day-names">
                    {DAY_NAMES_MINI.map(d => <div key={d} className="rp-day-name">{d}</div>)}
                </div>
                <div className="rp-days-grid">
                    {days.map((d, i) => {
                        if (!d) return <div key={`empty-${i}`} className="rp-day-cell empty" />;
                        
                        const selectedStart = isSameDay(d, selectionStart);
                        const selectedEnd = isSameDay(d, selectionEnd);
                        const inRange = isInRange(d);
                        
                        return (
                            <div 
                                key={d.getTime()} 
                                className={`rp-day-cell ${selectedStart ? 'selected-start' : ''} ${selectedEnd ? 'selected-end' : ''} ${inRange ? 'in-range' : ''}`}
                                onClick={() => handleDateClick(d)}
                                onMouseEnter={() => setHoverDate(d)}
                                onMouseLeave={() => setHoverDate(null)}
                            >
                                {d.getDate()}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    return (
        <div className="range-picker-overlay" onClick={onClose}>
            <div className="range-picker-content" onClick={e => e.stopPropagation()}>
                <div className="rp-nav">
                    <button className="rp-nav-btn" onClick={() => navigate(-1)}>◀</button>
                    <button className="rp-nav-btn" onClick={() => navigate(1)}>▶</button>
                    <button className="rp-close-btn" onClick={onClose}>✕</button>
                </div>
                <div className="rp-months-container">
                    {renderMonth(firstMonth)}
                    {renderMonth(secondMonth)}
                </div>
                <div className="rp-footer">
                    Wähle Start- und Enddatum für den Anzeigebereich.
                </div>
            </div>
        </div>
    );
}
